import { changeIndex } from '@/util/array';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Box } from '@mui/material';
import { FC } from 'react';

type ListArrowProps = {
  data: unknown[];
  index: number;
  onChange: (data: any[], arrowType: string) => void;
};

const ListArrows: FC<ListArrowProps> = (props) => {
  if (!props.data?.length) return <></>;

  const onArrowClick = (arrow: string) => {
    if (!props.data) return;
    const toIndex = arrow === 'up' ? props.index - 1 : props.index + 1;

    props.onChange(changeIndex(props.data, props.index, toIndex), arrow);
  };

  return (
    <Box display={'flex'} flexDirection={'column'} marginLeft={1}>
      <ArrowDropUpIcon
        onClick={() => props.index !== 0 && onArrowClick('up')}
        sx={{
          '&:hover': {
            cursor: 'pointer',
            color: 'gray'
          },
          visibility: props.index === 0 ? 'hidden' : 'visible'
        }}
      />
      <ArrowDropDownIcon
        onClick={() => props.data.length - 1 !== props.index && onArrowClick('down')}
        sx={{
          '&:hover': {
            cursor: 'pointer',
            color: 'gray'
          },
          visibility: props.data.length - 1 === props.index ? 'hidden' : 'visible'
        }}
      />
    </Box>
  );
};

export default ListArrows;
